import { SelectItem, MessageService } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { FormService } from 'src/app/core/services/form.service';
import { BranchService } from 'src/app/core/services/branch.service';
import { UserService } from 'src/app/core/services/user.service';
import { DatePipe } from '@angular/common';
import { UploadService } from 'src/app/core/services/upload.service';
import { ActivatedRoute } from '@angular/router';

interface Branches {
  name: string;
  code: string;
  id: number;
}

@Component({
  selector: 'app-patient-form',
  templateUrl: './patient-form.component.html',
  styleUrls: ['./patient-form.component.scss']
})
export class PatientFormComponent implements OnInit {
  edit = false
  newEdit: any = []
  public forms;
  public Forms;
  public date;
  public date1;
  public branch;
  public userDetails;
  public userid;
  public firstname;
  public lastname;
  public branches: SelectItem[];
  public selectBranch: Branches;
  public branchid;
  public formFetching;
  public therapistData;
  first = 0;
  therapists: any
  allTherapists: any;
  constructor(private formService: FormService,
    private datePipe: DatePipe,
    private branchService: BranchService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private userService: UserService,
    private uploadService: UploadService) {
    this.forms = [];
    this.branches = [];
    this.date = new Date();
    this.formFetching = false;
  }

  async ngOnInit() {
    this.allTherapists = await this.userService.getphisiolist()
    this.branch = await this.branchService.getBranch();
    this.processBranches(this.branch);
    console.log(this.branch);
  }

  processBranches(branch) {
    for (let i = 0; i < branch.length; i++) {
      const element = branch[i];
      this.branches.push({
        label: element.name,
        value: {
          id: element.branchid,
          name: element.name,
        }
      })
    }
  }

  async onSubmit() {
    this.formFetching = true;
    this.date1 = this.datePipe.transform(this.date, "yyyy-MM-dd");
    console.log(this.date1, this.selectBranch.id)
    const forms = await this.formService.getFormsByDate(this.date1, this.selectBranch.id);
    this.fetchForms(forms);
  }

  async fetchForms(formValue) {

    let tempForms = [];
    for (let i = 0; i < formValue.length; i++) {
      const element = formValue[i];

      //Get Branch Name
      const br: any = await this.branchService.getBranchByBranchId(element.branchid);
      element.branchName = br.name;

      //Get Uploaded forms
      const uploadedForms = await this.formService.getFormData(element.formid);
      element.uploadedForms = uploadedForms;
      tempForms.push(element);
    }

    this.forms = tempForms;
    this.formFetching = false;
    console.log(this.forms);

  }

  async onRowEditSave(form) {
    this.edit = false
    const body = {
      updates: {
        name: form.name,
        dob: this.datePipe.transform(form.dob, "yyyy-MM-dd"),
        tokenNo: form.tokenNo
      },
      formid: form.formid
    }

    try {
      await this.formService.updateForms(body);
    } catch {

    }
    if(this.therapistData) {
      const data = {
        userid: this.therapistData.userid,
        formid: this.therapistData.formid
      }
      await this.formService.addtherapist(data);
      this.therapistData.frm.therapist = this.therapistData.userid
    }
    this.messageService.add({ severity: 'success', summary: 'PeaceRiver', detail: 'Form Updated!!!' });
  }

  async onDownload(uploadedForm) {
    const url = await this.uploadService.getLinkForFile(uploadedForm.path);
    window.location.href = url;
  }
  async assign(event: any, formid: any, frm: any) {
    console.log(event.value.userid);
    const data = {
      userid: event.value.userid,
      formid: formid,
      frm: frm
    }
    this.therapistData = data;
    // const success = await this.formService.addtherapist(data)
    // if (success == "ok") {
    //   this.onSubmit()
    //   document.getElementById('cancel').click()
    //   return this.messageService.add({ severity: 'success', summary: 'PeaceRiver', detail: 'Therapist Assigned !' });
    // }
    // return this.messageService.add({ severity: 'error', summary: 'PeaceRiver', detail: 'Therapist Not Assigned !' });
  }

  async processTherapist(bid: any) {
    let obj = []
    for (let i = 0; i < this.allTherapists.length; i++) {
      const element = this.allTherapists[i];
      if (element.branchid == bid && element.state == 1) {
        obj.push(element)
      }
    }

    this.therapists = obj
    console.log(this.therapists);
  }

  async editbtn(form: any) {
    this.edit = true
    await this.processTherapist(form.branchid)

  }
  canceledit() {
    this.edit = false
  }
}
